<div class="enterprise-aml-form">
    <div class="form-group">
        <label for="enterprise_name" class="fw-bold text-xs">Enterprise Name</label>
        <input type="text" v-model="form.enterprise_name" id="enterprise_name" class="form-control text-xs rounded-small p-3 shadow-sm" required />
    </div>
    <div class="d-flex justify-content-end my-2">
        <button @click="handle_submit" class="btn btn-primary-color rounded-pill text-xs">
            Run Service
        </button>
    </div>
</div>